import React, { useCallback, useEffect, useState } from 'react'
import Header from 'components/Header'
import { Col, Row } from 'react-bootstrap'
import OrdersList from 'order_components/OrdersList'
import { IOrder } from 'order_components/IOrder'
import { reqGetAllOrders } from 'order_components/OrderRequests'
import MySpinner from 'components/MySpinner'

const HistoryPage: React.FC = () => {
  const [orders, setOrders] = useState<IOrder[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    let mount = true
    reqGetAllOrders((orders) => {
      if (mount) {
        setOrders(orders)
        setIsLoading(false)
      }
    })
    return () => {
      mount = false
    }
  }, [])

  const handleCancelOrder = useCallback(() => {
    setIsLoading(true)
    reqGetAllOrders((orders) => {
      setOrders(orders)
      setIsLoading(false)
    })
  }, [])

  return (
    <Row>
      <Col xs={12} className='pt-header'>
        <Header>История заказов</Header>
        {isLoading ? (
          <MySpinner />
        ) : orders.length === 0 ? (
          <div className='h3-rem'>История заказов пуста</div>
        ) : (
          <OrdersList orders={orders} onCancel={handleCancelOrder} />
        )}
      </Col>
    </Row>
  )
}
export default HistoryPage
